import React from "react";
import { Checkbox, Dropdown, Image, Tooltip } from "antd";
import { FileImageOutlined, FileTextOutlined, MoreOutlined } from "@ant-design/icons";
import moment from "moment";
import { FaRegFilePdf } from "react-icons/fa";
import { conterOfferContractTypes, createOfferContractTypes, listingContractTypes } from "../../Common/commondata/commonData";
import { hasPropertyDocsMenuItems } from "../../CreateOffer/features/helperFunctions";
import ProperyDocMenuItem from "./PropertyDocMenuItem";
import ContractTypeBadge from "../../Common/components/ContractTypeBadge";
import { formatBaseName } from "../../Common/utils/universalFuntions";
import ResureSign from "../../Assets/Icons/Resure_icon.png";

const SubFolderFile = ({ eachDoc, parentFolderId, level, role, getCoordinateItem, handlePropertyDocs, handleShareUnshareFileConfirm, handleToggleDashboard, handleDeletePropertyDocs, isSmallScreen, selectedFiles, hoveredRow, setHoveredRow, handleSelectFile, handleDragStart, handleCreateAmendExtend, handleEditName }) => {


  const ellispesStyle = {
    maxWidth: level === 1 ? "290px" : "240px",
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
    display: "inline-block",
  }


  return (
    <>
      <tr key={eachDoc?._id} draggable={!eachDoc?.isCustomerDoc} onDragStart={!eachDoc?.isCustomerDoc ? (e) => handleDragStart(e, { ...eachDoc, parentFolderId }) : undefined}>
        <td
          onClick={() => handlePropertyDocs(eachDoc)}
          style={{
            fontWeight: "bolder",
            color: "blue",
           minWidth: "250px",
            // width: "65%",
            width: level === 1 ? "63%" : level === 2 ? "61%" : "",
            cursor: "pointer",
            border: "none",
            paddingLeft: `${level * 22}px`,
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              fontSize: isSmallScreen ? "13px" : "16px",
            }}
          >
            <div
              style={{
                display: "flex",
                alignItems: "center",
              }}
            >
              <div style={{ width: "26px", height: "26px" }} onMouseEnter={() => setHoveredRow(eachDoc?._id)} onMouseLeave={() => setHoveredRow(null)}>
                {!eachDoc.isCustomerDoc && (hoveredRow === eachDoc?._id || selectedFiles?.propertyDocs?.filter((el) => el?.propertyDocId === eachDoc?._id)?.length || selectedFiles?.offerDocs?.filter((el) => el?.offerDocId === eachDoc?._id)?.length)|| (selectedFiles?.resureSignDocs?.filter((el) => el?.resureSignDocId === eachDoc?._id)?.length) ? (
                  <Checkbox
                    checked={eachDoc?.contractId ? selectedFiles?.offerDocs?.filter((el) => el?.offerDocId === eachDoc?._id)?.length : eachDoc?.isResureSignDoc ? selectedFiles?.resureSignDocs?.filter((el) => el?.resureSignDocId === eachDoc?._id).length: selectedFiles?.propertyDocs?.filter((el) => el?.propertyDocId === eachDoc?._id)?.length}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleSelectFile(eachDoc?._id, eachDoc?.contractId ? true : false, parentFolderId);
                    }}
                    style={{ marginRight: "4px" }}
                  />
                ) : (
                  <>
                    {eachDoc?.fileType === "IMAGE" ? (
                      <FileImageOutlined
                        style={{
                          color: "#ecd540",
                          marginTop: "5px",
                          marginRight: "5px",
                          fontSize: "18px",
                        }}
                      />
                    ) : eachDoc?.fileType === "PDF" || eachDoc?.isPdf || eachDoc?.pdfLink ? (
                      <FaRegFilePdf
                        style={{
                          color: "red",
                          marginRight: "5px",
                          fontSize: "18px",
                        }}
                      />
                    ) : eachDoc?.offerDocument && eachDoc?.contractType === "LCAES" ? (
                      <FileTextOutlined
                        style={{
                          color: "#74b3ed",
                          marginRight: "5px",
                          fontSize: "18px",
                        }}
                      />
                    ) : (
                      <FileTextOutlined
                        style={{
                          color: "#74b3ed",
                          marginRight: "5px",
                          fontSize: "18px",
                        }}
                      />
                    )}
                  </>
                )}
              </div>
              <ContractTypeBadge contractType={eachDoc?.contractType} additionalStyle={{ fontSize: "12px" }} />
              {eachDoc?.isResureSignDoc && (
                <Tooltip title="RE-Sure Sign Document">
                  <Image
                    style={{
                      objectFit: "contain",
                      height: "40px",
                      verticalAlign: "middle",
                      marginLeft: "5px",
                      marginRight: "-5px",
                    }}
                    height={40}
                    src={ResureSign}
                    preview={false}
                  ></Image>
                </Tooltip>
              )}
              <span style={ellispesStyle}>
                <Tooltip title={eachDoc?.updatedName ? eachDoc.updatedName.trim() : formatBaseName(eachDoc)}>
                  <span style={{ color: "blue" }}>{eachDoc?.updatedName ? eachDoc.updatedName.trim() : formatBaseName(eachDoc)}</span>
                </Tooltip>
                {eachDoc?.updatedName && (
                  <>
                    <br />
                    <Tooltip title={eachDoc?.offerDocument || eachDoc?.isCustomerDoc ? eachDoc?.documentName : eachDoc?.fileName}>
                      <span
                        style={{
                          fontSize: isSmallScreen ? "11px" : "14px",
                          color: "grey",
                        }}
                      >
                        ({eachDoc?.offerDocument || eachDoc?.isCustomerDoc ? eachDoc?.documentName : eachDoc?.fileName})
                      </span>
                    </Tooltip>
                  </>
                )}
                {eachDoc?.offerDocument && !eachDoc?.offerId && ![...listingContractTypes, "LCAES"].includes(eachDoc?.contractType) && <span style={{ color: "grey", fontSize: "12px" }}>{" (Without Buyers)"}</span>}
              </span>
            </div>
            {eachDoc?.transactionData && (
              <div
                style={{
                  color: "grey",
                  fontSize: "11px",
                  marginLeft: "24px",
                }}
              >
                {listingContractTypes.includes(eachDoc?.contractType) && eachDoc?.transactionData && eachDoc?.transactionData?.ListingPeriodBeginDate && <span>{moment(eachDoc?.transactionData?.ListingPeriodBeginDate).format("MM/DD/YYYY")}</span>}
                {listingContractTypes.includes(eachDoc?.contractType) && eachDoc?.transactionData && eachDoc?.transactionData?.ListingPeriodEndByDate && <> - {moment(eachDoc?.transactionData?.ListingPeriodEndByDate).format("MM/DD/YYYY")}</>}
                <span style={{ marginLeft: "19px" }}>
                  {eachDoc?.contractType === "LCAES" && eachDoc?.transactionData && eachDoc?.transactionData?.ListingPeriodEndByDate && <span>Ending Date </span>}
                  {eachDoc?.contractType === "LCAES" && eachDoc?.transactionData && eachDoc?.transactionData?.ListingPeriodEndByDate && <span> - {moment(eachDoc?.transactionData?.ListingPeriodEndByDate).format("MM/DD/YYYY")}</span>}
                </span>
              </div>
            )}
            <div
              style={{
                color: "grey",
                fontSize: "11px",
                marginLeft: "28px",
              }}
            >
              {eachDoc?.fileType ? `Uploaded by: ${eachDoc?.personId?.fullName}` : ""}
            </div>
          </div>
        </td>
        <td
          style={{
            color: "black",
            fontWeight: "500",
            textAlign: "center",
            // minWidth: "50px",
            width: level === 1 ? "200px" : "170px",
            whiteSpace: "nowrap",
            border: "none",
            overflow: "hidden",
          }}
        >
          <div>{moment(eachDoc?.createdDateMili).format("MM/DD/YYYY")}</div>
          <div>{moment(eachDoc?.createdDateMili).format("hh:mm A")}</div>
        </td>
      
        <td
          style={{
            textAlign: "center",
            // minWidth: "100px",
            width: level === 1 ? "16%" : level === 2 ? "15%" : "",
            border: "none",
          }}
        >
          {(eachDoc?.offerId && eachDoc?.offerDocument && eachDoc?.contractId && ![...listingContractTypes, "NET_SHEET"].includes(eachDoc?.contractType)|| eachDoc?.isResureSignDoc)  && (
            <Checkbox
              checked={eachDoc?.isCreatedInRtd}
              onChange={(e) => handleToggleDashboard(eachDoc, e.target.checked)}
              disabled={(eachDoc?.isCreatedInRtd && createOfferContractTypes?.includes(eachDoc?.contractType) && getCoordinateItem?.status === "ACCEPTED") || (getCoordinateItem?.isProperty && conterOfferContractTypes?.includes(eachDoc?.contractType) && getCoordinateItem?.propertyStatus !== "ACCEPTED")}
              style={{
                color: "black",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            />
          )}
           {!eachDoc?.contractId && !eachDoc?.isResureSignDoc? (
            role === "SELLER" && getCoordinateItem?.offerId ? (
              <Checkbox
                checked={eachDoc?.isShared}
                onChange={(e) => {
                  handleShareUnshareFileConfirm(eachDoc, e.target.checked);
                }}
                style={{
                  color: eachDoc?.isShared ? "white" : "black",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              />
            ) : role === "BUYER" && !eachDoc?.isResureSignDoc && eachDoc?.showSeller ? (
              <Checkbox
                checked={eachDoc?.isShared}
                onChange={(e) => {
                  handleShareUnshareFileConfirm(eachDoc, e.target.checked);
                }}
                style={{
                  color: eachDoc?.isShared ? "white" : "black",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              />
            ) : (
              <Tooltip title={role === "SELLER" && !getCoordinateItem?.offerId ? "Cannot share: Accepted offer does not exist." : role === "BUYER" && !eachDoc?.showSeller ? "Please send this offer to seller agent to enable sharing." : ""} placement="right" style={{ width: "50px" }}>
                <Checkbox
                  checked={false}
                  disabled={true}
                  style={{
                    color: "black",
                    borderRadius: "5px",
                    cursor: "not-allowed",
                  }}
                />
              </Tooltip>
            )
          ) : (
            <div />
          )}
        </td>

        <td
          style={{
            textAlign: "center",
            // minWidth: "70px",
            width: "8%",
            color: "#085191",
            border: "none",
          }}
        >
          {hasPropertyDocsMenuItems({ eachDoc, getCoordinateItem }) ? (
            <Dropdown overlay={<ProperyDocMenuItem parentDoc={eachDoc} eachDoc={eachDoc} getCoordinateItem={getCoordinateItem} handleDeletePropertyDocs={handleDeletePropertyDocs} handleCreateAmendExtend={handleCreateAmendExtend} />} trigger={["hover", "click"]}>
              <MoreOutlined
                key="ellipsis"
                style={{
                  fontSize: "26px",
                  color: "#08c",
                  marginRight: level === 1 ? "-28px" : level === 2 ? "-55px" : "",
                  paddingTop: "5px",
                }}
              />
            </Dropdown>
          ) : (
            <div />
          )}
        </td>
      </tr>
      {eachDoc?.matchedDocuments?.map((matchedDoc) => (
        <React.Fragment key={matchedDoc?._id}>
          <hr
            style={{
              // width: "100%",
              width: level === 1 ? "calc(100% - 35px)" : "calc(100% - 40px)",
              color: "#BFBFBF",
              margin: level === 1 ? "0 0 0 30px" : "0 0 0 35px",
              border: "none",
              borderTop: "1px solid #BFBFBF",
            }}
          />
          <tr key={matchedDoc?._id} style={{ borderLeft: "none", borderRight: "none" }}>
            <td
              style={{
                fontWeight: "bolder",
                color: "blue",
                // minWidth: "250px",
                cursor: "pointer",
                width: "48%",
                paddingLeft: `${(level + 1) * 21}px`,
                border: "none",
              }}
              onClick={() => handlePropertyDocs(matchedDoc)}
            >
              <div style={{ display: "flex", alignItems: "center" }}>
                <FileTextOutlined
                  style={{
                    color: "#74b3ed",
                    marginRight: "5px",
                    fontSize: "18px",
                  }}
                />
              <span style={ellispesStyle}>
                  <Tooltip title={matchedDoc?.updatedName ? matchedDoc.updatedName.trim() : formatBaseName(matchedDoc)}>
                    <span style={{ color: "blue" }}>{matchedDoc?.updatedName ? matchedDoc.updatedName.trim() : formatBaseName(matchedDoc)}</span>
                  </Tooltip>
                  {matchedDoc?.updatedName && (
                    <>
                      <br />
                      <Tooltip title={matchedDoc?.documentName || matchedDoc?.fileName}>
                        <span
                          style={{
                            fontSize: isSmallScreen ? "11px" : "14px",
                            color: "grey",
                          }}
                        >
                          ({matchedDoc?.documentName || matchedDoc?.fileName})
                        </span>
                      </Tooltip>
                    </>
                  )}
                </span>
              </div>
              {matchedDoc.transactionData?.ListingPeriodEndByDate && (
                <div
                  style={{
                    color: "grey",
                    fontSize: "11px",
                    marginLeft: "5px",
                  }}
                >
                  <span style={{ marginLeft: "19px" }}>
                    {<span>Ending Date </span>}
                    {<span> - {moment(matchedDoc.transactionData.ListingPeriodEndByDate).format("MM/DD/YYYY")}</span>}
                  </span>
                </div>
              )}
            </td>

            <td style={{ color: "black", fontWeight: "500", textAlign: "center", width: "170px", whiteSpace: "nowrap", border: "none" }}>
              <div>{moment(matchedDoc?.createdDateMili).format("MM/DD/YYYY")}</div>
              <div>{moment(matchedDoc?.createdDateMili).format("hh:mm A")}</div>
            </td>
            <td style={{ textAlign: "center", width: "10%", border: "none" }}>
              <div></div>
            </td>
            <td
              style={{
                textAlign: "center",
                minWidth: "100px",
                width: "15%",
                border: "none",
              }}
            >
              <div></div>
            </td>
            <td style={{ textAlign: "center", width: "10%", border: "none" }}>
              {hasPropertyDocsMenuItems({eachDoc:matchedDoc, getCoordinateItem }) ? (
                <Dropdown overlay={<ProperyDocMenuItem parentDoc={eachDoc} eachDoc={matchedDoc} getCoordinateItem={getCoordinateItem} handleCreateAmendExtend={handleCreateAmendExtend} handleDeletePropertyDocs={handleDeletePropertyDocs} />} trigger={["hover", "click"]}>
                  <MoreOutlined
                    key="ellipsis"
                    style={{
                      fontSize: "26px",
                      color: "#08c",
                      marginRight: "-58px",
                      paddingTop: "5px",
                    }}
                  />
                </Dropdown>
              ) : (
                <div />
              )}
            </td>
          </tr>
        </React.Fragment>
      ))}
    </>
  );
};

export default SubFolderFile;
